import React from 'react';
import { observer } from '../../shared/observer';

// Надпись о товарах «Продажа не сегодня» в корзине — как в приложении: когда приедет
// заказ и, если в корзине есть обычные товары, кнопки «Убрать …», чтобы получить
// остальное сегодня. Показывать ли и тексты (с учётом «Настроек заказов») решает
// сервер: MobileCartV3Serializer#no_today_sale_notice.

const TruckIcon = () => (
  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" aria-hidden="true">
    <path d="M3 7h11v9H3z" stroke="currentColor" strokeWidth="1.6" />
    <path d="M14 10h4l3 3v3h-7z" stroke="currentColor" strokeWidth="1.6" />
    <circle cx="7" cy="17.5" r="1.8" stroke="currentColor" strokeWidth="1.6" />
    <circle cx="17" cy="17.5" r="1.8" stroke="currentColor" strokeWidth="1.6" />
  </svg>
);

class NoTodaySaleNoteView extends React.Component {
  remove = (line) => {
    // откат при ошибке делает стор; reject глушим от unhandled rejection
    this.props.cart.removeProductFromCart(line.item_id, line.topping_ids).catch(() => {});
  };

  render() {
    const cart = this.props.cart;
    const notice = cart.cart.no_today_sale_notice;
    if (!notice || !notice.items || !notice.items.length || !notice.title) return null;

    return (
      <div className="ng-no-today-note">
        <div className="ng-no-today-note__head">
          <span className="ng-no-today-note__icon"><TruckIcon /></span>
          <strong className="ng-no-today-note__title">{notice.title}</strong>
        </div>
        <p className="ng-no-today-note__text">{notice.text}</p>
        {notice.mixed && (
          <div className="ng-no-today-note__actions">
            {notice.items.map((it) => {
              const line = cart.items.find((ci) => ci.item_id === it.item_id);
              if (!line) return null;
              return (
                <button
                  type="button"
                  key={it.item_id}
                  className="ng-no-today-note__remove"
                  onClick={() => this.remove(line)}
                >
                  {(notice.remove_text || 'Убрать {товар}').split('{товар}').join('«' + it.title + '»')}
                </button>
              );
            })}
          </div>
        )}
      </div>
    );
  }
}

export const NoTodaySaleNote = observer(NoTodaySaleNoteView, ['cartStore']);



// WEBPACK FOOTER //
// ./app/javascript/website_newgen/js/components/Cart/NoTodaySaleNote.jsx